// ─────────────────────────────────────────────────────────────────────────────
// Mack · the six blocks — ONE definition of the vocabulary, the order, and the
// strongest-block rule.
//
// Extracted in build-10. Before this, `MackBlockKey` lived in CalculatorTab and
// crossed to Phases as a type-only import, the block ORDER was declared three
// times (Calculator, Phases as PHASE_BLOCKS, Overview), and the strongest-block
// derivation existed in THREE copies (Calculator inline, Phases.strongestOf,
// Overview.strongestOf). Three copies of a derivation rule is the thing that
// drifts — exactly what the standing ruling targets.
//
// NOTE ON THE BUILD-10 PREMISE: the brief expected a STORED strongestBlock on
// Phases that had drifted from its vector. There was none — Phases already
// derived it, and its own interface said so. The real defect was the triplication
// above, which is what this module fixes. Reported rather than assumed.
//
// BLOCK ORDER IS LOAD-BEARING TWICE: it is the render order of the vector, and
// it is the tie-break for strongest block — ties resolve to first in block order.
// ─────────────────────────────────────────────────────────────────────────────

export type MackBlockKey = 'Policy' | 'Prices' | 'Growth' | 'External' | 'Positioning' | 'Risk';

export const BLOCK_ORDER: MackBlockKey[] =
  ['Policy', 'Prices', 'Growth', 'External', 'Positioning', 'Risk'];

// The strongest block in a vector. Ties resolve to first in BLOCK_ORDER — the
// reduce keeps the incumbent on equality, which is what produces that.
export function strongestBlock(v: Partial<Record<MackBlockKey, number>>): MackBlockKey {
  return BLOCK_ORDER.reduce(
    (best, k) => ((v[k] ?? 0) > (v[best] ?? 0) ? k : best),
    BLOCK_ORDER[0],
  );
}

// Thirds banding, shared by every surface that colours a block value:
// verified against every value printed on Calculator, Phases and Backtest.
export function blockBandThirds(v: number, green: string, amber: string, red: string): string {
  if (v >= 2 / 3) return green;
  if (v >= 1 / 3) return amber;
  return red;
}
